import type { MouseEvent, ReactNode } from "react";
import { cn } from "../../../utils/cn";

type DSOverlayRootProps = {
  children: ReactNode;
  className?: string;
  closeOnOverlayClick?: boolean;
  onClose?: () => void;
};

function DSOverlayRoot({
  children,
  className,
  closeOnOverlayClick = true,
  onClose,
}: DSOverlayRootProps) {
  function handleOverlayClick(event: MouseEvent<HTMLDivElement>) {
    if (!closeOnOverlayClick) {
      return;
    }

    if (event.target === event.currentTarget) {
      onClose?.();
    }
  }

  return (
    <div
      className={cn("fixed inset-0 z-[70] bg-overlay/24", className)}
      data-slot="overlay-root"
      data-testid="overlay-root"
      onClick={handleOverlayClick}
    >
      {children}
    </div>
  );
}

export { DSOverlayRoot };
